var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-padding"},[_c('b-container',{staticClass:"documents"},[_c('page-show',{attrs:{"alias":'documents'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }